import dayjs from "dayjs";

export const getDaysPastDate = (daysBefore: number, inputDate = dayjs().tz()): dayjs.Dayjs => {
  return inputDate.subtract(daysBefore, 'day');
}

export const toIsoString = (date: dayjs.Dayjs): string => {
  return date.format('YYYY-MM-DDTHH:mm:ssZ');
}
